import React from 'react';
import { Wallet, RefreshCw, Gift } from 'lucide-react';

interface WalletHeaderProps {
  loading: boolean;
  onRefresh: () => void;
  onAddTokens: () => void;
}

export function WalletHeader({ loading, onRefresh, onAddTokens }: WalletHeaderProps) {
  return (
    <div className="p-6 border-b border-gray-700">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/20 rounded-lg">
            <Wallet className="text-blue-400" size={24} />
          </div>
          <h2 className="text-2xl font-bold text-white">Wallet</h2>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onRefresh}
            className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
            disabled={loading}
          >
            <RefreshCw className={`text-gray-400 ${loading ? 'animate-spin' : ''}`} size={20} />
          </button>
          <button
            onClick={onAddTokens}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg transition-colors text-white"
            disabled={loading}
          >
            <Gift size={20} />
            Add $30
          </button>
        </div>
      </div>
    </div>
  );
}